import AwardStar from './AwardStar';
export default AwardStar;
